export default {
    routerName: '文章发布',
    routerNamePic: '图片裁剪',
    article: {
        title: '标题',
        description: '描述',
        body: '详细',
        author: '作者',
        tag: '标签',
        tagName: '标签名',
        status: '状态',
        status0: '草稿',
        status1: '審査拒绝',
        status2: '審査中',
        status9: '審査成功',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        disabled: '禁用',
        yes: '是',
        no: '否',
        thumb: '缩略图',
        image: '图片',
        default: '默认',
        top: '详细TOP',
        category: '类别',
        hot: '热门',
        recommend: '推荐报道',
        recommendTop: '推荐TOP',
        topic: 'TOPIC',
        slider: '幻灯片',
        hits: '浏览量',
        version: '版本',
        releaseTime: '公开时间',
    },
    menu: {
        title: '分类菜单',
        name: '菜单',
        setting: '详细设定',
    },
};
